// src/xml-icon.tsx
import { createSvgIcon } from "@mui/material";
import { jsx } from "react/jsx-runtime";
var XMLIcon = createSvgIcon(
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m19.698 7.2-5.132-5-.201-.2H5.409c-.403 0-.805.2-1.006.4C4.2 2.6 4 3 4 3.4v5.1h1.409V3.4h8.05v4.3c0 .2.1.4.201.5.101.1.302.2.504.2H20v-.7c0-.1-.07-.26-.302-.5Zm-4.83-.2V4.4L17.484 7h-2.616Zm-9.47 11.62.916-3.46h.01l.906 3.46H8.64l-.996-4.46.996-4.47H7.23l-.905 3.37h-.01l-.876-3.37H4l.996 4.47L4 18.62h1.399Zm.01 2.38c-.402 0-.704-.1-1.005-.4C4.1 20.3 4 20 4 19.6h15.9c0 .4-.101.7-.403 1-.201.2-.604.4-1.006.4H5.409Zm10.064-2.38V9.69h-2.164l-.684 6.1-.674-6.1H9.786v8.93h1.208v-6.63l.734 6.62h1.801l.735-6.62v6.63h1.208Zm1.197-8.93h1.208v7.72h2.022v1.2h-3.23V9.69Z",
      clipRule: "evenodd"
    }
  ),
  "XMLIcon"
);

export {
  XMLIcon
};
